import { render } from "./TeacherPaperManageView.vue?vue&type=template&id=bd309b32&scoped=true"
import script from "./TeacherPaperManageView.vue?vue&type=script&lang=js"
export * from "./TeacherPaperManageView.vue?vue&type=script&lang=js"

import "./TeacherPaperManageView.vue?vue&type=style&index=0&id=bd309b32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd309b32"]])

export default __exports__